class ReferenceSlider extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-reference-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 38,
            breakpoints: {
                512: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                prevEl: '[data-reference-prev]',
                nextEl: '[data-reference-next]'
            },
        });
    }
}
